import React from "react";

/**
 * 어노테이션 텍스트 슬롯 props — OL 레이어로 직접 렌더링되므로 DOM 반환 없음.
 *
 * 어노테이션 컴포넌트(`Polygon`/`Polyline`/`Rectangle` 등)의 `<InnerText>` 자식으로 사용.
 */
export interface InnerTextProps {
  color?: string;
  size?: number;
  outline?: boolean;
  children: string;
  isPopup?: boolean;
  upperText?: boolean;
}

export function InnerText({
  color,
  size,
  outline,
  children,
  isPopup = false,
  upperText = false,
}: InnerTextProps) {
  // 반환 DOM이 없는 컴포넌트 (OpenLayers 레이어로 직접 렌더링)
  return null;
}
